var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.402 18.486l3.92 5.57a1.681 1.681 0 002.73.082l12.55-15.884"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 2A2.4 2.4 0 003 4.4v14.4c0 7.7 11.575 16.27 15.509 18.816a2.362 2.362 0 002.582 0C25.025 35.07 36.6 26.501 36.6 18.8V4.4A2.402 2.402 0 0034.2 2H5.4z"
  })));
}
export default SvgShield;